import { useEffect, useMemo, useState } from 'react'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import { AppLoader } from '../../../Components/common/AppLoader/AppLoader'
import { useNavigate } from 'react-router-dom'
import {
  fetchProductCategories,
  fetchProductsForDisplay,
  mapProductToCardProps,
} from '../../../api/productApi'
import '../partnerhospitals/partnerhospitals.css'
import './bizaariostore.css'

const HOME_PAGE_SIZE = 3
const ALL_CATEGORY = 'all'

export const Bizaariostore = () => {
  const navigate = useNavigate()
  const [categories, setCategories] = useState([])
  const [products, setProducts] = useState([])
  const [activeCategoryId, setActiveCategoryId] = useState(ALL_CATEGORY)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      setLoading(true)
      setError('')
      try {
        const [categoryRows, productRows] = await Promise.all([
          fetchProductCategories(),
          fetchProductsForDisplay(),
        ])
        if (cancelled) return

        setCategories(categoryRows)
        setProducts(productRows.map(mapProductToCardProps))
        setActiveCategoryId(ALL_CATEGORY)
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load products.')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    return () => { cancelled = true }
  }, [])

  const filteredProducts = useMemo(() => {
    const list = activeCategoryId === ALL_CATEGORY
      ? products
      : products.filter((product) => String(product.categoryId) === String(activeCategoryId))
    return list.slice(0, HOME_PAGE_SIZE)
  }, [products, activeCategoryId])

  return (
    <section className="bizaario-store">
      <Container fluid className="px-0">

        {/* Header */}
        <Row className="align-items-start mobile-col justify-content-between mb-4">
          <Col>
            <h2 className="bizaario-store__title">Bizaario Store</h2>
            <p className="bizaario-store__subtitle">
              Shop smarter for your health — curated medical supplies and wellness products at your fingertips.
            </p>
          </Col>
          <Col xs="auto" className="mt-1">
            <Button className="partner-hospitals__view-all" onClick={() => navigate('/store')}>View All &nbsp;→</Button>
          </Col>
        </Row>

        {!loading && !error && (
          <div className="bizaario-store__tabs-wrap">
            <div className="partner-hospitals__tabs-wrap">
              <div className="partner-hospitals__tabs">
                <button
                  type="button"
                  className={`partner-hospitals__tab ${activeCategoryId === ALL_CATEGORY ? 'partner-hospitals__tab--active' : ''}`}
                  onClick={() => setActiveCategoryId(ALL_CATEGORY)}
                >
                  All
                </button>
                {categories.map((category) => (
                  <button
                    key={category.product_category_id}
                    type="button"
                    className={`partner-hospitals__tab ${String(activeCategoryId) === String(category.product_category_id) ? 'partner-hospitals__tab--active' : ''}`}
                    onClick={() => setActiveCategoryId(category.product_category_id)}
                  >
                    {category.product_category}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {loading && (
          <AppLoader className="py-5" />
        )}

        {!loading && error && (
          <p className="text-center py-4 text-danger">{error}</p>
        )}

        {!loading && !error && (
          <Row xs={1} md={2} lg={3} className="g-4">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <Col key={product.id}>
                  <Card
                    className="bizaario-store__card border-0"
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate(`/store/${product.slug}`)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        navigate(`/store/${product.slug}`)
                      }
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="bizaario-store__card-image-wrapper">
                      <Card.Img
                        variant="top"
                        src={product.image}
                        alt={product.title}
                        className="bizaario-store__card-image"
                      />
                    </div>
                    <Card.Body className="bizaario-store__card-body px-0">
                      <Card.Title className="bizaario-store__card-title">
                        {product.title}
                      </Card.Title>
                      <Card.Text className="bizaario-store__card-desc">
                        {product.description}
                      </Card.Text>
                      <Button
                        className="bizaario-store__card-btn w-100"
                        onClick={(e) => {
                          e.stopPropagation()
                          navigate(`/store/${product.slug}`)
                        }}
                      >
                        Request a Quote
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <p className="text-center py-4">No products available for this category.</p>
              </Col>
            )}
          </Row>
        )}

      </Container>
    </section>
  )
}
